import { useCallback, useEffect, useState } from 'react';
import { useMediaQuery, useTheme } from '@mui/material';

/**
 * WhatsApp-style mobile navigation: list first, chat after user tap, back returns to list.
 * Desktop (md+) always shows both panels side-by-side.
 */
export default function useMobileChatNav(activeUserPhone, onCloseProfile) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down('md'), { noSsr: true });
  const [mobileChatOpen, setMobileChatOpen] = useState(false);

  useEffect(() => {
    if (!isMobileLayout) {
      setMobileChatOpen(false);
    }
  }, [isMobileLayout]);

  useEffect(() => {
    if (!activeUserPhone) {
      setMobileChatOpen(false);
    }
  }, [activeUserPhone]);

  const openMobileChat = useCallback(() => {
    if (isMobileLayout) {
      setMobileChatOpen(true);
    }
  }, [isMobileLayout]);

  const backToUserList = useCallback(() => {
    onCloseProfile?.();
    setMobileChatOpen(false);
  }, [onCloseProfile]);

  const showMobileChat =
    isMobileLayout && mobileChatOpen && Boolean(activeUserPhone);
  const showMobileList = !isMobileLayout || !mobileChatOpen;

  return {
    isMobileLayout,
    showMobileChat,
    showMobileList,
    openMobileChat,
    backToUserList,
  };
}
